import config from '@frolight/config';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const ROOT_URL = `${config.api.uri}/peripherals`;

const LIST_URL = `${ROOT_URL}/`;

export const getPeripheralInfoByDeviceIds = async (abortController, accessToken, { peripheralDeviceIds }) => {
  let url = LIST_URL;

  peripheralDeviceIds.forEach((deviceId, i) => {
    if (i === 0) {
      url += '?';
    } else {
      url += '&';
    }
    url += `deviceIds[]=${deviceId}`;
  });

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`
      },
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};